import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectAllCaptionsState = (state: RootState) => state.captions;

export const selectIsRttActive = createSelector(selectAllCaptionsState, (state) => state.isRttActive);

export const selectShowCaptions = createSelector(selectAllCaptionsState, (state) => state.showCaptions);

export const selectCaptionsHasError = createSelector(selectAllCaptionsState, (state) => state.hasError);

export const selectCaptionLines = createSelector(selectAllCaptionsState, (state) => state.lines);

export const selectSpeakerColors = createSelector(selectAllCaptionsState, (state) => state.speakerColorByUid);
